import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import { getCookieOptions } from "../utils/cookieUtils";

const CaseInfoContext = createContext(null);

export const CaseInfoProvider = ({ children }) => {
  const [caseInfo, setCaseInfo] = useState(null);
  const [caseInfoLoading, setCaseInfoLoading] = useState(false);
  const [caseInfoError, setCaseInfoError] = useState(null);

  const payload = GetPayLoad("PayLoad");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
  const headers = {
    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
    "X-Hps-Region": payload?.region ?? Cookies.get("region") ?? "",
    "X-Hps-Carrier": payload?.owning_carrier ?? Cookies.get("owningCarrier") ?? "",
  };
  const cimNumber = sessionStorage.getItem('cimNumber') || payload?.cim;
  const loadCaseInfo = async () => {
    console.log("Loading case info for CIM:", cimNumber);
    console.log("Using headers:", headers);
    console.log("Target case URL:", targetCaseUrl);
    if (!cimNumber || !targetCaseUrl) {
      return;
    }
    setCaseInfoLoading(true);
    setCaseInfoError(null);
    try {
      const response = await getApiService(
        baseUrl,
        targetCaseUrl,
        { cim: cimNumber, apiSource: "settings" },
        headers
      );
      if (response?.data?.statusCode === 200) {
        const result = response.data.data;
        setCaseInfo(result);
        if (result?.isUSAAFaq !== undefined) {
          Cookies.set("isUsaaFaq", result.isUSAAFaq ? "true" : "false", getCookieOptions());
        }
        if (result?.isNonUSAAFaq !== undefined) {
          Cookies.set("isNonUsaaFaq", result.isNonUSAAFaq ? "true" : "false", getCookieOptions());
        }
      } else {
        setCaseInfo(null);
      }
    } catch (error) {
      setCaseInfoError(error);
      setCaseInfo(null);
    } finally {
      setCaseInfoLoading(false);
    }
  };

  useEffect(() => {
    if (cimNumber) {
      loadCaseInfo();
    }
  }, [cimNumber, payload?.region ?? Cookies.get("region") ?? "", payload?.owning_carrier ?? Cookies.get("owning_carrier") ?? ""]);

  return (
    <CaseInfoContext.Provider value={{ caseInfo, setCaseInfo, caseInfoLoading, caseInfoError, loadCaseInfo }}>
      {children}
    </CaseInfoContext.Provider>
  );
};

export const useCaseInfo = () => {
  const context = useContext(CaseInfoContext);
  if (!context) {
    throw new Error("useCaseInfo must be used within a CaseInfoProvider");
  }
  return context;
};

export default CaseInfoContext;
